<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
        [titulo]      = "DAT_TITULOS.titulo"
        [modulo]      = "DAT_TITULOS.modulo"
        [tituloCard]  = "DAT_TITULOS.tituloCardList"
        [innTemplate] = "enviarTemplateEdit"
        [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
        <div class="col-md-6 mb-2">
        <div class="pagetitle">
            <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" class="btn btn-outline-success"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
            </div>
        </div>
        </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>

        <div class="form-group col-md-12">
        <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
            (keyup)="onQuickFilterChanged() " #quickFilter />
        </div>
        <br>

        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                        [id]    ="DAT_AG_GRID.id" 
                        [class] ="DAT_AG_GRID.class" 
                        [ngStyle]="DAT_AG_GRID.style" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        [pagination]="DAT_AG_GRID.pagination" 
                        [rowSelection]="rowSelection"
                        [paginationPageSize]="DAT_AG_GRID.pagina"
                        [allowContextMenuWithControlKey]="true"
                        [frameworkComponents]="frameworkComponents" >
        </ag-grid-angular>

    </ng-template>
    <!-- GRILLA -->
</div>

  
<!-- MODAL -->
<app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-lg'" [idButton] = "'abrirModal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
</app-lfsa-modal>

<ng-template #abrirModal>
    <div class="container-fluid">
        <form [formGroup]="formulario" mat-dialog-content>
            <div class="row">
                <div class="col">
                    <app-lfsa-input formControlName="cedula" [label]="'* Ingrese cedula'" [id]="'cedula'" [control]="formulario.get('cedula')" 
                    [placeholder]="'Ingrese Cédula del Empleado'" (change)="getEmpleado($event);" [type]="'text'" [isReadOnly]="!isCreate" >
                    </app-lfsa-input>
                </div>

                <div class="col">
                    <app-lfsa-input formControlName="nombres" [label]="'Nombre Empleado'" [id]="'nombres'" [control]="formulario.get('nombres')" [type]="'text'" [isReadOnly]="true" >
                    </app-lfsa-input>
                </div>

                <div class="col">
                    <app-lfsa-input formControlName="dscaLocalidad" [label]="'Localidad'" [id]="'dscaLocalidad'" [control]="formulario.get('dscaLocalidad')" [type]="'text'" [isReadOnly]="true" >
                    </app-lfsa-input>
                </div>

                <div class="col">
                    <app-lfsa-input formControlName="statusEmpleado" [label]="'Estado'" [id]="'statusEmpleado'" [control]="formulario.get('statusEmpleado')" [type]="'text'" [isReadOnly]="true" >
                    </app-lfsa-input>
                </div>
            </div>

            <div class="row center" *ngIf="!isCreate"> 
                <div class="btn-group-justified btn-group" style="float: right;">
                    <button (click)="acciones('regresar')" class="btn btn-outline-danger"> <i aria-hidden="true" class="fa fa-arrow-left"></i> Regresar </button>
                </div>
            </div>

            <app-lfsa-botones-formulario *ngIf="isCreate"
                (devolverAccion) ="acciones($event)" 
                [formularioValido] ="formulario.invalid" 
                [loading]="loading" class="row p-3">
            </app-lfsa-botones-formulario>
        </form>
    </div>
</ng-template>
<!-- END MODAL --> 
